module.exports = __webpack_public_path__ + "home_safety.f10836b290e773b48e9b.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/home_safety.jpg
// module id = ../../../../../src/assets/img/home_safety.jpg
// module chunks = styles